import 'lazysizes'
import ProductImageGallery from './components/product/ImageGallery'
import Popup from "./components/popup/Popup";
import initializeProductFilter from './components/product/ProductFilter'
import { isNil } from './helpers'
import backbone from 'backbone'
import { MegaMenuView } from './modules/megaMenu'
import interactiveTeaser from './modules/teasers/interactiveTeaser'
import assortmentTeaser from './modules/teasers/assortmentTeaser'
import replaceCollapsibleButtonText from './modules/replaceCollapsibleButtonText'

// import ParquetFinderReloaded from './modules/parquetFinderReloaded/parquetFinderReloaded';
// import ParquetFinderReloaded from '../../../../BauwerkGroup.BauwerkParkettCom.Catalog/Resources/Private/Fusion/Presentation/Application/InteractiveParquetFinder/InteractiveParquetFinder';

define([
    'jquery',
    'lodash',
    './core/layout',
    './core/page/page',
    './core/overlay',
    './core/sticky',
    './core/tooltip',
    './core/share',
    './core/tracking',
    './core/cookies',
    './modules/header/header',
    './modules/slider',
    './modules/progressiveImages',
    './modules/forms/forms',
    './modules/modal',
    './modules/filters/filters',
    './modules/overlays/overlays',
    './modules/teasers/teasers',
    './modules/content/content',
    './modules/box/box',
    './modules/search/search',
    './modules/finder/finders',
    './modules/parketFilters/parketFilters',
    './modules/bookmarks/bookmarks',
    './modules/section/sectionHeader',
    './pages/home',
    './pages/campaign',
    './pages/parketsortiment',
    './modules/store/favouriteStore',
    './modules/favourites/favourites',
    './modules/priceCalculator/priceCalculator',
    './modules/leadProcess/leadProcess',
    './modules/productSearch',
    './modules/highresSearch',
    './modules/login',
    './modules/languageSelector',
    './modules/languageHint',
    './modules/cookiesInfo',
    './utils',
    './modules/datePicker',
    './materialize-modify/tabs-extender',
    'velocity',
    'materializeGlobal',
    'dropdown',
    'forms',
    'materializeModal',
    'carousel',
    'collapsible',
    'tabs',
    'sideNav',
    'iframeresizer',
    'jqueryMaskPlugin',
    'jqueryEasing',
    'mmenu',
    'lazysizes',
], function($, _, Layout, Page, Overlay, Sticky, Tooltips, Share, Tracking, Cookies, Header, Slider, ProgressiveImages, Forms, Modals, Filters, Overlays, Teasers, Content, Box, Search, Finder, ParketFinder, Bookmarks, SectionHeader, Home, Campaign, ParketSortiment, FavouriteStore, Favourites, PriceCalculator, LeadProcess, ProductSearch, HighresSearch, Login, LanguageSelector, LanguageHint, CookiesInfo, Utils, DatePicker, TabsExtender) {

    if (typeof window.console === 'undefined') {
        window.console = {};
        console.log = _.noop;
        console.warn = _.noop;
        console.error = _.noop;
    }

    function init() {
        var layout = new Layout();
        var page = new Page(layout);
        var overlay = new Overlay();
        var sticky = new Sticky();
        var share = new Share();
        var tracking = new Tracking();
        window.tracking = tracking;
        var overlays = new Overlays(overlay);
        var progressiveImages = new ProgressiveImages();
        var header = new Header(overlay, layout);
        var slider = new Slider(layout);
        var forms = new Forms();
        var modals = new Modals();
        var filters = new Filters();
        var teasers = new Teasers(layout);
        var content = new Content();
        var box = new Box(layout);
        var search = new Search(header, overlay);
        var finder = new Finder();
        // var parketFinder = new ParketFinder(layout);
        var bookmarks = new Bookmarks();
        var favourites = new Favourites();
        var priceCalculator = new PriceCalculator();
        var leadProcess = new LeadProcess();
        var productSearch = new ProductSearch();
        var sectionHeader = new SectionHeader();
        var highresSearch = new HighresSearch(overlays);
        var tabsExtender = new TabsExtender();

        if (document.getElementById('parketfinder')) {
            // ParquetFinderReloaded(document.getElementById('parketfinder'))
        }

        // init platform check
        const mobileDevice = (/iphone|ipad|ipod|android|blackberry/i.test(navigator.userAgent.toLowerCase()));
        if (mobileDevice) {
            document.body.classList.add('platform-mobile');
        }
        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            document.body.classList.add('platform-ios');
        }

        //pages
        var home = new Home();
        var campaign = new Campaign();
        var sortPage = new ParketSortiment(layout);

        var favouriteStore = new FavouriteStore();

        var login = new Login();
        var languageSelector = new LanguageSelector();
        var languageHint = new LanguageHint();
        var cookiesInfo = new CookiesInfo();

        layout.init();
        overlay.init();
        sticky.init();
        share.init();

        overlays.init();
        progressiveImages.init();
        header.init();
        slider.init();
        forms.init();
        modals.init();
        filters.init();
        teasers.init();

        // parketFinder.init();

        var contentModules = content.init();
        box.init();

        search.init();
        finder.init();
        bookmarks.init();
        favourites.init();
        priceCalculator.init();
        leadProcess.init();
        productSearch.init();
        highresSearch.init();

        sectionHeader.init();


        home.init();
        campaign.init();
        sortPage.init();

        login.init();
        // keep the order of languageSelector & languageHint init() calls!
        languageSelector.init();
        languageHint.init();
        cookiesInfo.init();

        initializeMaterializeElements();
        initMaterialize();
        tabsExtender.init();
        iframeResizer();

        page.on('getPageDone', function(e) {

            tooltips.init();

            overlay.hideOverlay();

            page.resetScrollPosition(1);

            header.initSubheader();

            slider.init();
            progressiveImages.init();

            forms.init();
            modals.init();
            filters.init();
            teasers.init();

            // parketFinder.init();

            sectionHeader.init();

            box.init();

            contentModules = content.init();

            finder.init();

            overlays.init();

            home.init();
            campaign.init();
            sortPage.init();

            share.init();

            search.checkLastQuery();

            initializeMaterializeElements();
            initMaterialize();
            iframeResizer();

            priceCalculator.init();
            leadProcess.init();
            productSearch.init();
            highresSearch.init();

            favourites.matchSelected();
            favourites.loadFavouritesPageContent();

            bookmarks.updateProductButtonState();

            $('.collapsible').collapsible();

            var openCalcOverlayParam = Utils.getQueryStringParams('calculateOveralay', window.location.href);
            if (openCalcOverlayParam) {
                var $calculatorOverlay = $('#calculatorOverlay');
                if ($calculatorOverlay.length > 0) {
                    overlay.openOverlay(
                        $calculatorOverlay
                    )
                }
            }

        });

        filters.on('filter:content:contentChanged', function($contentCollection) {

            var progressiveImageInstance = progressiveImages.getProgressiveInstace();
            progressiveImageInstance.addItems(
                progressiveImageInstance.getProgressiveItems(
                    $contentCollection.get(0)
                )
            );

            contentModules.contentLoadMore.init();
            box.init();

        });

        overlays.on('overlay:calculator:calculateBeforeOpen', function(productData) {

            var urlDomain = '';

            var $element = $(' .favourites__action__wrapper');

            var productSorting = $('[data-product-sorting-value]').get(0);
            var productSurface = $('[data-product-surface-value]').get(0);

            if (productSorting) {

                var productSortingValue = $(productSorting).attr('data-product-sorting-value');
                var productSurfaceValue = $(productSurface).attr('data-product-surface-value')

                if (Object.keys(productData['product']).length == 0) {
                    $element.attr('data-fav-param-wood', productSortingValue);
                    $element.attr('data-fav-param-surface', productSurfaceValue);
                } else {
                    if (productSortingValue != productData['product']['selected']['wood']) {
                        $element.attr('data-fav-param-wood', productSortingValue);
                        $element.attr('data-fav-param-surface', productSurfaceValue);
                    } else {
                        $element.attr('data-fav-param-wood', productData['product']['selected']['wood']);
                        $element.attr('data-fav-param-surface', productData['product']['selected']['surface']);
                    }
                }
            }

            var _this = this;

            var favAction = (productData['exist']) ? 'replace' : 'add';

            favourites.processItem($element.get(0), favAction).then(function() {
                priceCalculator.calculateSingle().then(function() {
                    overlays.overlayCalculator.openCalculatorOverlayAfterCalculation();
                }, function() {});
            }, function() {});

        });

        overlays.on('overlay:share:favsBeforeOpen', function() {

            var urlDomain = '';

            var $element = $('.teaser--product .favourites__action__wrapper');

            favourites.processItem($element.get(0), 'new').then(function() {
                overlays.overlayShare.postAddOpenTerminOverlay();
            }, function() {
                overlays.overlayShare.postAddOpenTerminOverlay();
            });

        });

        overlay.on('openOverlay', function($overlay) {

            var progressiveImageInstance = progressiveImages.getProgressiveInstace();
            progressiveImageInstance.checkBreak();

            finder.initFinder($overlay);

            setTimeout(function() {
                $(window).trigger('scroll');
                $(window).trigger('resize');
            });

        });

        overlays.on('overlay:page:contentAdded', function($contentCollection) {

            var progressiveImageInstance = progressiveImages.getProgressiveInstace();
            progressiveImageInstance.addItems(
                progressiveImageInstance.getProgressiveItems(
                    $contentCollection.get(0)
                )
            );

            forms.initNewForms();

            initializeMaterializeElements();
            initMaterialize();
            tabsExtender.init();
            $('.collapsible').collapsible();

        });

        contentModules.contentLoadMore.on('content:loadmore:show', function() {

        });

        favourites.on('favourites:set', function(data) {

            favouriteStore.setFavourites(data);

            priceCalculator.processTerminMapLinks(data.general.code);

            setTimeout(function() {

                header.updateFavValue(
                    header.$favElement, header.$favElement.parent(), String(data.general.count)
                );

                bookmarks.updateBookmarks();

            }, 750);

        });

        favourites.on('favourites:remove', function(id, type, data, $element) {

            favouriteStore.setFavourites(data);

            favourites.removeFavourites(id, type, $element);

            setTimeout(function() {

                header.updateFavValue(
                    header.$favElement, header.$favElement.parent(), String(data.general.count)
                );

                bookmarks.updateBookmarks();

            }, 750);

        });

        favourites.on('favourites:pagecontent', function() {
            favourites.loadTabsContent();
            overlays.init();
        });

        favourites.on('favourites:tabscontent', function() {
            initializeMaterializeElements();
            tabsExtender.init();
            favourites.bindEvents();
            progressiveImages.init();
            $('.favourites__sorting-select select').material_select();
        });

        priceCalculator.on('favourites:beforecalculation:insert', function(item) {

            var _this = this;

            favourites.processItem(item, 'new').then(function() {
                _this.emit('favourites:calculation');
            }, function() {
                _this.emit('favourites:calculation');
            });

        });

        priceCalculator.on('favourites:calculation', function(item) {
            priceCalculator.calculateSingle();
        });

        priceCalculator.on('favourites:calculated', function(preserveOverlay) {
            favourites.postCalulationUpdateFavourites();
            if (!preserveOverlay) {
                overlay.hideOverlay();
            };
        });


        header.on('header:favMouseOver', function() {
            if ('ontouchstart' in window) {
                return;
            }

            bookmarks.displayBookmarkPopup();

        });

        header.on('header:favMouseOut', function() {
            bookmarks.hideBookmarkPopup();
        });

        // parketFinder.getFiltersModulesInstances().filtersContent.on('parketfinder:loadMore:matchSelected', function() {
        //     favourites.matchSelected(favourites.addSelectedClass);
        // });

        // parketFinder.getFiltersModulesInstances().filtersContent.on('parketfinder:filters:reload', function(url) {

        //     if (url) {
        //         page.updateHistory(url);
        //     }

        //     $('.collapsible').collapsible();
        //     initMaterialize();

        //     tooltips.init();

        //     favourites.matchSelected();

        // });

        home.on('home:preloadClonedImages', function($collection) {

            var progressiveImageInstance = progressiveImages.getProgressiveInstace();
            $collection.each(function(index, container) {
                progressiveImageInstance.addItems(
                    progressiveImageInstance.getProgressiveItems(
                        container
                    )
                );
            });

        });

        campaign.on('campaign:preloadClonedImages', function($collection) {

            var progressiveImageInstance = progressiveImages.getProgressiveInstace();
            $collection.each(function(index, container) {
                progressiveImageInstance.addItems(
                    progressiveImageInstance.getProgressiveItems(
                        container
                    )
                );
            });

        });

        highresSearch.on('hiResResults', function(url) {

            if (url) {
                page.updateHistory(url);
            }

            initMaterialize();
            initializeMaterializeElements();
            tabsExtender.init();
            contentModules.contentLoadMore.init();

            overlays.init();

        });

        leadProcess.on('terminLeadFormReloaded', function(url) {
            leadProcess.updateFormFavValuesAfterSubmit();
        });

        bookmarks.on('bookmarkContentLoaded', function() {
            setTimeout(function() {
                favourites.updateCurrentBucketFavouritesStorage();
            }, 750);
        });

        setTimeout(function() {

            var itemsCount = (favouriteStore.getFavourites() !== undefined) ? favouriteStore.getFavourites().general.count : '';

            header.updateFavValue(
                header.$favElement, header.$favElement.parent(), itemsCount
            );

        }, 3000);

        window.addEventListener("message", function(event) {

            var urlDomain = '';

            if (event && event.data && event.data.actionType == 'addProductToFavourites') {

                // var urlDomain = window.location.href.match('localhost') ? 'http://10.0.0.204:81' : '';
                var urlDomain = '';

                $.get(urlDomain + '/favourites/resolveItem?slug=' + event.data.productSlug + '&itemNumber=' + event.data.productId + '&lang=' + $('html').attr('lang')).then(function(response) {

                    var $element = $('<div></div>');
                    $element.attr('data-fav-type', 'product');
                    $element.attr('data-fav-id', response.data.identifier);

                    $element.attr('data-url', urlDomain + '/favourites/write?node=/sites/bauwerk');

                    favourites.processItem($element.get(0), 'new');

                });
            }

            if (event && event.data && event.data.actionType == 'addPictureToFavourites') {

                var $element = $('<div></div>');

                $element.attr('data-fav-type', 'picture');
                $element.attr('data-fav-url', event.data.pictureUrl);

                $element.attr('data-url', urlDomain + '/favourites/write?node=/sites/bauwerk');
                favourites.processItem($element.get(0), 'new');

            }

            if (event && event.data && event.data.actionType == 'addPdfToFavourites') {

                var $element = $('<div></div>');

                var openPdfUrl = urlDomain + '/pdf/pdf.pdf?language=de&variant=' + event.data.config.itemnumber + '&image=' + event.data.config.imageConfig;

                var pdfPreview = 'http://int.bauwerk-parkett.com.bauwerkparkett01.nine.ch/configurator/' + event.data.config.imageConfig;

                $element.attr('data-fav-type', 'picture');
                $element.attr('data-fav-url', openPdfUrl);
                $element.attr('data-fav-pdf', openPdfUrl);
                $element.attr('data-fav-pdf-preview', pdfPreview);

                $element.attr('data-url', urlDomain + '/favourites/write?node=/sites/bauwerk');

                favourites.processItem($element.get(0), 'new');

            }

            if (event && event.data && event.data.actionType == 'pdfAction') {

                var openPdfUrl = urlDomain + '/pdf/pdf.pdf?language=de&variant=' + event.data.config.itemnumber + '&image=' + event.data.config.imageConfig;
                window.open(openPdfUrl);

            }

            if (event && event.data && event.data.actionType == 'addPreCalculationItem') {

                // console.log(event, 'addPreCalculationItem');

            }

        }, false);

        window.addEventListener('thankYouPageShow', function() {

            // console.log('thankYouPageShow bootstrap');

            var bucket = favouriteStore.getFavourites();
            bucket.header.is_saved = 1;
            favouriteStore.setFavourites(bucket);

            // console.log('bucket ', bucket);

            $.ajax({
                type: "POST",
                url: '/bucket/saved/' + Cookies.getCookie('favourites'),
                data: {
                    "fav": JSON.stringify(bucket)
                }
            }).done(function(data) {
                if (data.updated) {
                    bucket.header.is_saved = 0;
                    favourtiesStore.setFavourites(bucket);
                }
            });
        })
    }

    function initMaterialize() {

        try {
            window.Materialize.updateTextFields();
        } catch (e) {}

        $('select').material_select();
    }

    function initializeMaterializeElements() {

        $('.tabs').tabs({
            onShow: function(container) {

                var $slider = container.find('.slick-slider');

                if ($slider && $slider.length) {

                    var index = $slider.slick('slickCurrentSlide');
                    $slider.slick('slickGoTo', index);

                }
            }
        });
    }

    function iframeResizer() {
        $('iframe.soundcloud').iFrameResize({
            minHeight: '100'
        });

        $('iframe').iFrameResize({
            minHeight: '700'
        });

    }

    function identifyUser() {

        var userCookie = Cookies.getCookie('uid');
        if (!userCookie) {
            Cookies.setCookie('uid', makeid(), 9999999);
        }

        function makeid() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            for (var i = 0; i < 15; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        }

    }

    function mobileMenu() {
        const menu = document.querySelector('.header__mobile__nav--links')

        if (!menu) return;

        const labelAll = menu.dataset.labelAll
        const labelProfessional = menu.dataset.labelProfessional
        const labelBack = menu.dataset.labelBack

        new Mmenu("#mobile-nav", {
            navbar: {
                title: " "
            },
            "extensions": [
                "border-none",
                "position-front",
                "position-left"
            ],
            "navbars": [{
                "position": "top",
                "type": "tabs",
                "content": [
                    "<a href='#mm-all'>" + labelAll + "</a>",
                    "<a href='#mm-professional'>" + labelProfessional + "</a>"
                ]
            }]
        }, {
            offCanvas: {
                clone: true
            }
        });

        $("#mm-mobile-nav .mm-navbar_sticky .mm-navbar__title").html(labelBack);
    }

    const productGalleryElements = Array.from(document.querySelectorAll('.page--assortmentitem .product-header-image'))
    if (!isNil(productGalleryElements)) {
        productGalleryElements.forEach((element) => {
            new ProductImageGallery(element)
        })
    }

    const popupElements = Array.from(document.querySelectorAll('.popup-container'))
    if (popupElements && popupElements.length > 0) {
        popupElements.forEach((element) => {
            new Popup(element)
        });
    }

    let tooltips = new Tooltips();
    const initializeTooltips = () => {
        tooltips.init();
    }

    const reinitializeTooltips = () => {
        tooltips.reinit();
    }

    if (window.addEventListener) {
        window.addEventListener(
            'reinitializeTooltips',
            reinitializeTooltips,
            false
        )

        window.addEventListener(
            'initializeTooltips',
            initializeTooltips,
            false
        )
    }

    function megaMenu() {

        var mouseInsideNav = function(target) {
            var isNav = $(target).closest('.header__nav').length > 0
            var isNavItem = $(target).closest('.header__nav > ul').length > 0

            if (isNav && !isNavItem) {
                return true
            }
        }

        window.MainMenuView = new MegaMenuView({
            el: '.mainnav__link.menu__item',
            mega: '.mainnav__link-subitems-wrapper',
            mouseInside: mouseInsideNav
        })
    }

    $.datepicker.regional["fr"] = {
        closeText: "Fermer",
        prevText: "&#x3C;Préc",
        nextText: "Suiv&#x3E;",
        currentText: "Courant",
        monthNames: ["janvier", "février", "mars", "avril", "mai", "juin",
            "juillet", "août", "septembre", "octobre", "novembre", "décembre"
        ],
        monthNamesShort: ["janv.", "févr.", "mars", "avril", "mai", "juin",
            "juil.", "août", "sept.", "oct.", "nov.", "déc."
        ],
        dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
        dayNamesShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
        dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
        weekHeader: "Sm",
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    };

    $.datepicker.regional["de"] = {
        closeText: "Schließen",
        prevText: "&#x3C;Zurück",
        nextText: "Vor&#x3E;",
        currentText: "Heute",
        monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni",
            "Juli", "August", "September", "Oktober", "November", "Dezember"
        ],
        monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
            "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
        ],
        dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        weekHeader: "KW",
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    };

    $.datepicker.regional["it"] = {
        closeText: "Chiudi",
        prevText: "&#x3C;Prec",
        nextText: "Succ&#x3E;",
        currentText: "Oggi",
        monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
            "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
        ],
        monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu",
            "Lug", "Ago", "Set", "Ott", "Nov", "Dic"
        ],
        dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        weekHeader: "Sm",
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    };

    $('document').ready(function() {
        initializeProductFilter();
        identifyUser()
        mobileMenu()
        megaMenu()
        interactiveTeaser()
        assortmentTeaser()
        replaceCollapsibleButtonText()
        initializeTooltips()
        init()
    });

});



// WEBPACK FOOTER //
// ./Private/Scripts/application.js